export default "__VITE_ASSET__NsoBJ_Lb__"